import axios from "axios";

const BASE_URL = `/m-1/questionnaire`;

/**
 * Serwis do komunikacji z API - endpoint /survey
 */
export const SurveyService = {
  fetchSurvey,
  storeSurvey,
  fetchTypes,
  fetchAnswers,
  downloadAnswersPDF,
  getDevelopmentAreas,
  downloadFeedback,
  checkIsSurveyActive,
  getAllClientAnswers,
  checkCourses,
  checkIsSecondOrderAvailable
};

function fetchSurvey(surveyId) {
  return axios.get(`${BASE_URL}/${surveyId}`);
}

function checkIsSurveyActive(questionnaireType, clientId) {
  return axios.get(`${BASE_URL}/is-active/${questionnaireType}/${clientId}`);
}

function storeSurvey(data, userId, questionnaireId) {
  return axios.post(
    `${BASE_URL}/set/answer/${userId}/${questionnaireId}`,
    data
  );
}

function fetchAnswers(userId, questionnaireId) {
  return axios.get(`${BASE_URL}/answer/${userId}/${questionnaireId}`);
}

function fetchTypes() {
  return axios.get(`${BASE_URL}/types`);
}

function downloadAnswersPDF(userId, questionnaireId) {
  return axios.post(
    `${BASE_URL}/answer/downland/summary/${userId}/${questionnaireId}`,
    null,
    {
      responseType: "blob",
    }
  );
}

function getDevelopmentAreas(phrase) {
  return axios.get(`${BASE_URL}/answer/subcategory/${phrase}`);
}

function downloadFeedback(userId) {
  return axios.post(`${BASE_URL}/downland/feedback/${userId}`, null, {
    responseType: "blob",
  });
}

function getAllClientAnswers(client_id) {
  return axios.get(`${BASE_URL}/client/${client_id}`);
}

 async function checkCourses(payload) {
  try {
    const res = await axios.post(
      "/m-1/questionnaire/check-courses",
      payload,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    // succes
    const raw = res?.data ?? {};
    const invalidCourses = Array.isArray(raw?.invalidCourses)
      ? raw.invalidCourses
      : Array.isArray(raw?.data?.invalidCourses)
      ? raw.data.invalidCourses
      : [];

    return {
      ok: true,
      status: res?.status ?? 200,
      data: { ...raw, invalidCourses },
    };
  } catch (e) {
    const status = e?.response?.status;
    const body = e?.response?.data;

    const invalidCourses =
      (Array.isArray(body?.invalidCourses) && body.invalidCourses) ||
      (Array.isArray(body?.data?.invalidCourses) && body.data.invalidCourses) ||
      [];

    const errors = body?.errors ?? {};
    const message = body?.message ?? "The given data was invalid.";

    return {
      ok: false,
      validation: status === 422 || status === 400 || status === 500,
      status,
      data: { invalidCourses },
      errors,
      message,
    };
  }
}

function checkIsSecondOrderAvailable(client_id) {
  return axios.get(`${BASE_URL}/can-order/4/${client_id}`);
}